export const resolveVariant = {
  DISABLE: 'disable',
  HIDE: 'hide',
};

export const hasPermission = ({ workspacePermissions, permission }) =>
  workspacePermissions.includes(permission);
